import { createRouter, createWebHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import Login from "@/views/authentication/Login.vue";
import HomeView from "@/views/HomeView.vue";
import CostumersList from "@/views/CostumersList.vue";
import CostumerDetails from "@/views/CostumerDetails.vue";
import InspectionForm from "@/views/InspectionForm.vue";
import Settings from "@/views/Settings.vue";
import ContractForm from "@/views/ContractForm.vue";
import ContractDetails from "@/views/ContractDetails.vue";
import PlanningView from "@/views/PlanningView.vue";
import PlanningDeadlines from "@/views/PlanningDeadlines.vue";
import ZonesList from "@/views/ZonesList.vue";
import ArchivedCostumersList from "@/views/ArchivedCostumersList.vue";
import ZonesDetails from "@/views/ZonesDetails.vue";
import CalendarView from "@/views/CalendarView.vue";
import ContractExpirationsList from "@/views/ContractExpirationsList.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: HomeView,
    },
    {
        path: "/login",
        name: "loginRoute",
        component: Login,
    },
    {
        path: "/costumers",
        name: "costumers",
        component: CostumersList,
    },
    {
        path: "/costumers/archived",
        name: "archivedCostumers",
        component: ArchivedCostumersList,
    },
    {
        path: "/costumers/contracts",
        name: "contractExpirations",
        component: ContractExpirationsList,
    },
    {
        path: "/costumers/zones",
        name: "zones",
        component: ZonesList,
    },
    {
        path: "/costumers/zones/:zoneId",
        name: "zoneDetails",
        component: ZonesDetails,
    },
    {
        path: "/costumers/:costumerId",
        name: "costumerDetails",
        component: CostumerDetails,
    },
    {
        path: "/costumers/:costumerId/inspections/:inspectionId",
        name: "costumerInspectionForm",
        component: InspectionForm,
    },
    {
        path: "/costumers/:costumerId/inspections/new",
        name: "newCostumerInspectionForm",
        component: InspectionForm,
    },
    {
        path: "/costumers/:costumerId/contracts/:contractId/form",
        name: "contractForm",
        component: ContractForm,
    },
    {
        path: "/costumers/:costumerId/contracts/:contractId",
        name: "contractDetails",
        component: ContractDetails,
    },
    {
        path: "/planning",
        name: "planning",
        component: PlanningView,
    },
    {
        path: "/planning/:week",
        name: "planning-by-week",
        component: PlanningView,
    },
    {
        path: "/planning/deadlines",
        name: "planning-deadlines",
        component: PlanningDeadlines,
    },
    {
        path: "/calendar",
        name: "calendar",
        component: CalendarView,
    },
    {
        path: "/settings",
        name: "settings",
        component: Settings,
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    if (authStore.isAuthenticated || to.name === "loginRoute") {
        next();
    } else {
        next("/login");
    }
});

export default router;
